import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    editUserRole: [],
    loading: false,
    error: null,
}

const editUserRoleSlice = createSlice({
    name: "editUserRole",
    initialState,
    reducers: {
        fetcheditUserRoleSuccess: (state, action) => {
            state.loading = false,
            state.editUserRole = action.payload;
        },
        fetcheditUserRoleFailure: (state, action) => {
            state.loading = false,
            state.error = action.payload;
        },
    },
})

export const {
    fetcheditUserRoleSuccess,
    fetcheditUserRoleFailure,
} = editUserRoleSlice.actions;

export default editUserRoleSlice.reducer;